import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import $ from "./jquery";

(function () {
  // init swiper
  function init() {
    new Swiper(".js-flb-estl-swiper-gallery", {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
      },

      loop: false,

      // Navigation arrows
      pagination: { el: ".swiper-pagination", clickable: true },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  init();

  $("[data-unit-loader='gallery']").on("estl:unit:loaded", function () {
    init();
  });
})();
